import { useSelector } from 'react-redux';
import { IS_USER_WITH_ONLY_CLOUD } from 'reactApp/appHelpers/configHelpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

export const useContent = ({ isMarketingPromo, isSubscriptionsPage }) => {
    const isAlmostFull = useSelector(UserQuotaSelectors.isAlmostFull);
    const isFull = useSelector(UserQuotaSelectors.isFull);
    const is100PercentFull = useSelector(UserQuotaSelectors.is100PercentFull);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isB2BUser = useSelector(UserSelectors.isB2BUser);
    const isBiz = useSelector(UserSelectors.isBizUser);

    const isOverquota = isAlmostFull || isFull;

    let warning = '';

    if (isAlmostFull) {
        warning = 'Хранилище почти заполнено';
    }
    if (isFull) {
        warning = 'Хранилище переполнено';
    }
    if (is100PercentFull) {
        warning = 'Хранилище заполнено';
    }

    let buttonText = 'Увеличить место';

    const isMySubscription = isPaidUser && !isOverquota;
    if (isMySubscription) {
        buttonText = 'Мои подписки';
    }

    if (isMarketingPromo) {
        buttonText = 'Скидка 50%';
    }

    const buttonState = {
        primary: !isMySubscription && !isOverquota,
        secondary: isMySubscription,
        error: isOverquota,
    };

    return {
        buttonText,
        warning,
        buttonState,
        hideButton: isSubscriptionsPage || isB2BUser,
        isMySubscription,
        hideMenu: (isSubscriptionsPage && IS_USER_WITH_ONLY_CLOUD) || isBiz,
    };
};
